/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import moment from 'moment-timezone'
import React, { useEffect, useImperativeHandle, useState } from 'react'

import globalNotification from 'live/services/global-notification'
import i18n from 'live/services/i18n'

import {
    exportResourceBarrierStatus,
    getResourceBarrierStatusEvent
} from 'plugin-codaf-risk-ext-bowtie/services/reportEvents'
import { IBarrierStatusSpecialStatus } from 'plugin-codaf-risk-ext-bowtie/types'
import { OrderFields } from 'plugin-codaf-risk-ext-bowtie/types/enums'
import { IResourceBarrierStatusReport } from 'plugin-codaf-risk-ext-bowtie/types/reports'

import { NoData, NoInfo } from '../../styles'
import { ReportPopover } from '../ReportFilter/ReportPopover'

interface IProps {
    setItemsLength: (k: number) => void
    start: number
    numberOfItems: number
    time: string | null
    startDay: string | null
    endDay: string | null
    startHour: string | null
    endHour: string | null
    page: number
    setPage: (k: number) => void
    dictionaryStatusMap: Map<number, IBarrierStatusSpecialStatus>
    setExportLoading: (k: boolean) => void
}

interface IOrder {
    field: string
    order: boolean
}

export const ResourceBarrierStatus = React.forwardRef<any, IProps>(function ResourceBarrierStatus(
    {
        setItemsLength,
        numberOfItems,
        startDay,
        startHour,
        endDay,
        endHour,
        page,
        setPage,
        dictionaryStatusMap,
        setExportLoading
    },
    ref
) {
    const [isLoading, setIsLoading] = useState(false)
    const [events, setEvents] = useState<IResourceBarrierStatusReport>()

    const [order, setOrder] = useState<IOrder>({ field: OrderFields.DATE, order: true })

    const [searchResource, setSearchResource] = useState<string>('')
    const [listResource, setListResource] = useState(new Set<string>())
    const [filterResource, setFilterResource] = useState(new Set<string>())

    const [searchBowtieCode, setSearchBowtieCode] = useState<string>('')
    const [listBowtieCode, setListBowtieCode] = useState(new Set<string>())
    const [filterBowtieCode, setFilterBowtieCode] = useState(new Set<string>())

    const [searchBarrierId, setSearchBarrierId] = useState<string>('')
    const [listBarrierId, setListBarrierId] = useState(new Set<string>())
    const [filterBarrierId, setFilterBarrierId] = useState(new Set<string>())

    const [searchBarrierName, setSearchBarrierName] = useState<string>('')
    const [listBarrierName, setListBarrierName] = useState(new Set<string>())
    const [filterBarrierName, setFilterBarrierName] = useState(new Set<string>())

    const [searchType, setSearchType] = useState<string>('')
    const [listType, setListType] = useState(new Set<string>())
    const [filterType, setFilterType] = useState(new Set<string>())

    const [searchEntity, setSearchEntity] = useState<string>('')
    const [listEntity, setListEntity] = useState(new Set<string>())
    const [filterEntity, setFilterEntity] = useState(new Set<string>())

    const [searchCategory, setSearchCategory] = useState<string>('')
    const [listCategory, setListCategory] = useState(new Set<string>())
    const [filterCategory, setFilterCategory] = useState(new Set<string>())

    const [searchStatus, setSearchStatus] = useState<string>('')
    const [listStatus, setListStatus] = useState(new Set<string>())
    const [filterStatus, setFilterStatus] = useState(new Set<string>())

    const [searchDate, setSearchDate] = useState<string>('')
    const [listDate, setListDate] = useState(new Set<string>())
    const [filterDate, setFilterDate] = useState(new Set<string>())

    const [update, setUpdate] = useState<number>()

    const dateConverter = (data): string => {
        const newDate = new Date(data)
        const converted = moment(newDate).format('YYYY/MM/DD, hh:mm:ss a')

        return `${converted}`
    }

    const renderTableRow = (): JSX.Element[] => {
        if (events?.reportEvent) {
            const renderObject = events?.reportEvent.map((item, index) => {
                return (
                    <tr key={index} className={`resource-barrier-status ${index === 0 ? 'first-margin' : ''}`}>
                        <td valign="middle" className={'common-width'}>
                            {item.resource}
                        </td>
                        <td valign="middle" className={'common-width'}>
                            {item.bowtieCode}
                        </td>
                        <td valign="middle" className={'common-width'}>
                            {item.barrierId}
                        </td>
                        <td valign="middle" className={'common-width'}>
                            {item.barrierName}
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <span className="type">{i18n(item.type)}</span>
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <span>{item.entity}</span>
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <span>{item.category}</span>
                        </td>
                        <td valign="middle" className={'common-width'}>
                            <span className={`barrierStatus ${item.status} `} style={{ color: item.statusColor }}>
                                {i18n(item.status)}
                            </span>
                        </td>
                        <td valign="middle" className={'common-width'}>
                            {dateConverter(item.date)}
                        </td>
                    </tr>
                )
            })

            return renderObject
        }
    }

    const dateFormatToRequisition = (dateToConvert): string => {
        const initialDateToRequisition = new Date(dateToConvert)
        const formatedInitialDate = moment(initialDateToRequisition).format('YYYY-MM-DD')

        return formatedInitialDate
    }

    const formatSetToArray = (setToFormat: Set<string>): string[] => {
        const arr = []
        setToFormat.forEach(item => {
            arr.push(item)
        })

        return arr
    }

    const convertDateToTs = (dateToTs: Set<string>): string[] => {
        const arr = []
        dateToTs.forEach(item => {
            const dateFormating = new Date(item).getTime()
            arr.push(dateFormating)
        })

        return arr
    }

    const getEvents = async (): Promise<void> => {
        try {
            setIsLoading(true)
            const barrierEvents = await getResourceBarrierStatusEvent({
                startDay: dateFormatToRequisition(startDay),
                startHour: startHour,
                endDay: dateFormatToRequisition(endDay),
                endHour: endHour,
                page: page,
                perPage: numberOfItems,
                sortBy: order.field,
                sortOrder: order.order ? 'ASC' : 'DESC',
                filterByResource: formatSetToArray(filterResource),
                filterByBowtieCode: formatSetToArray(filterBowtieCode),
                filterByBarrierId: formatSetToArray(filterBarrierId),
                filterByBarrierName: formatSetToArray(filterBarrierName),
                filterByType: formatSetToArray(filterType),
                filterByEntity: formatSetToArray(filterEntity),
                filterByCategory: formatSetToArray(filterCategory),
                filterByStatus: formatSetToArray(filterStatus),
                filterByDate: convertDateToTs(filterDate)
            })
            setEvents(barrierEvents)
            setItemsLength(barrierEvents.total)
        } catch (err) {
            globalNotification.error(err.message ?? i18n('An error occurred on list events.'))
        } finally {
            setIsLoading(false)
        }
    }

    const onClearAllFilters = (): void => {
        setUpdate(update + 1)
        globalNotification.success(i18n('Filters removed successfully.'))
    }

    useImperativeHandle(ref, () => ({
        async exportResourceBarrierStatus() {
            try {
                setExportLoading(true)
                await exportResourceBarrierStatus({
                    startDay: dateFormatToRequisition(startDay),
                    startHour: startHour,
                    endDay: dateFormatToRequisition(endDay),
                    endHour: endHour,

                    sortBy: order.field,
                    sortOrder: order.order ? 'ASC' : 'DESC',
                    filterByResource: formatSetToArray(filterResource),
                    filterByBowtieCode: formatSetToArray(filterBowtieCode),
                    filterByBarrierId: formatSetToArray(filterBarrierId),
                    filterByBarrierName: formatSetToArray(filterBarrierName),
                    filterByType: formatSetToArray(filterType),
                    filterByEntity: formatSetToArray(filterEntity),
                    filterByCategory: formatSetToArray(filterCategory),
                    filterByStatus: formatSetToArray(filterStatus),
                    filterByDate: convertDateToTs(filterDate)
                })
                globalNotification.success(i18n('Report exported successfully.'))
            } catch (error) {
                globalNotification.error(i18n('Error on exporting report.'))
            } finally {
                setExportLoading(false)
            }
        }
    }))

    useEffect(() => {
        getEvents()
    }, [
        startDay,
        startHour,
        endDay,
        endHour,
        page,
        order,
        filterResource,
        filterBowtieCode,
        filterBarrierId,
        filterBarrierName,
        filterType,
        filterEntity,
        filterStatus,
        filterCategory,
        filterDate
    ])

    useEffect(() => {
        setPage(1)
    }, [
        order,
        filterResource,
        filterBowtieCode,
        filterBarrierId,
        filterBarrierName,
        filterType,
        filterEntity,
        filterStatus,
        filterCategory,
        filterDate
    ])

    return (
        <>
            <button className="clearAllFilters" onClick={() => onClearAllFilters()}>
                {i18n('Clear all filter view')}
                <i className="far fa-filter"></i>
            </button>
            <div className="tableContainer customScroll">
                <table>
                    <thead className="tableHeader">
                        <tr className={'resource-barrier-status-header'}>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchResource}
                                    setSearch={setSearchResource}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.RESOURCE}
                                    list={listResource}
                                    setList={setListResource}
                                    filter={filterResource}
                                    setFilter={setFilterResource}
                                    onClearAll={update}
                                    buttonTitle={'resource'}
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchBowtieCode}
                                    setSearch={setSearchBowtieCode}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.BOWTIECODE}
                                    list={listBowtieCode}
                                    setList={setListBowtieCode}
                                    filter={filterBowtieCode}
                                    setFilter={setFilterBowtieCode}
                                    onClearAll={update}
                                    buttonTitle="bowtie code"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchBarrierId}
                                    setSearch={setSearchBarrierId}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.BARRIER_ID}
                                    list={listBarrierId}
                                    setList={setListBarrierId}
                                    filter={filterBarrierId}
                                    setFilter={setFilterBarrierId}
                                    onClearAll={update}
                                    buttonTitle="barrier id"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchBarrierName}
                                    setSearch={setSearchBarrierName}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.BARRIER_NAME}
                                    list={listBarrierName}
                                    setList={setListBarrierName}
                                    filter={filterBarrierName}
                                    setFilter={setFilterBarrierName}
                                    onClearAll={update}
                                    buttonTitle="barrier name"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchType}
                                    setSearch={setSearchType}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.TYPE}
                                    list={listType}
                                    setList={setListType}
                                    filter={filterType}
                                    setFilter={setFilterType}
                                    onClearAll={update}
                                    buttonTitle="type"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchEntity}
                                    setSearch={setSearchEntity}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.ENTITY}
                                    list={listEntity}
                                    setList={setListEntity}
                                    filter={filterEntity}
                                    setFilter={setFilterEntity}
                                    onClearAll={update}
                                    buttonTitle="entity name"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchCategory}
                                    setSearch={setSearchCategory}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.CATEGORY}
                                    list={listCategory}
                                    setList={setListCategory}
                                    filter={filterCategory}
                                    setFilter={setFilterCategory}
                                    onClearAll={update}
                                    buttonTitle="category"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchStatus}
                                    setSearch={setSearchStatus}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.STATUS}
                                    list={listStatus}
                                    setList={setListStatus}
                                    filter={filterStatus}
                                    setFilter={setFilterStatus}
                                    onClearAll={update}
                                    buttonTitle="status"
                                />
                            </th>
                            <th className={'common-width'}>
                                <ReportPopover
                                    search={searchDate}
                                    setSearch={setSearchDate}
                                    order={order}
                                    setOrder={setOrder}
                                    field={OrderFields.DATE}
                                    list={listDate}
                                    setList={setListDate}
                                    filter={filterDate}
                                    setFilter={setFilterDate}
                                    onClearAll={update}
                                    buttonTitle="date/time"
                                    last
                                />
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {isLoading ? (
                            <NoInfo>
                                <i className="fa fa-spinner fa-spin" />
                            </NoInfo>
                        ) : events?.total === 0 ? (
                            <NoData>{i18n('There is no data for the specified period.')}</NoData>
                        ) : (
                            renderTableRow()
                        )}
                    </tbody>
                </table>
            </div>
        </>
    )
})
